/**
 * Recolor an EFFIS RDA PNG in place. Bright mapped polygons become a dark
 * diagonal hatch so the scar reads as ground, not a live hotspot.
 */
export function hatchBurnedRgba(px: Uint8ClampedArray, width: number, height: number): void {
  const period = 7;
  const stripe = 3;
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const i = (y * width + x) * 4;
      // Nodata / water is transparent. Do not paint a box over the basemap.
      if ((px[i + 3] ?? 0) < 24) {
        px[i] = 0;
        px[i + 1] = 0;
        px[i + 2] = 0;
        px[i + 3] = 0;
        continue;
      }
      const on = ((x + y) % period) < stripe;
      if (on) {
        px[i] = 52;
        px[i + 1] = 34;
        px[i + 2] = 20;
        px[i + 3] = 190;
      } else {
        px[i] = 26;
        px[i + 1] = 17;
        px[i + 2] = 11;
        px[i + 3] = 110;
      }
    }
  }
}
